/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { FaGlobe, FaPhoneAlt } from "react-icons/fa";
import { useQuery } from "@tanstack/react-query";
import { StarsSafety } from "../http/server-apis";
import { Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const LinkList = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);
  const navigate = useNavigate()
  const [linkList, setLinkList] = useState([]);
  const linkLoader = [1, 2, 3, 4, 5, 6, 7];
  const { isLoading } = useQuery(
    ["get-all-link"],
    () =>
      StarsSafety("get", {
        postfix: `?LangCode=${selectedLanguage}`,
      }),
    {
      onSuccess(data) {
        if (data?.status === 200)
          if (data.data.Status === "success")
            setLinkList(
              data.data.Safety instanceof Array ? data.data.Safety : []
            );
      },
    }
  );

  return (
    <>
      {isLoading ? (
        <>
          {linkLoader.map((link, index) => (
            <div
              key={index}
              className=" border border-gray-200 py-3 mx-auto  m-5 rounded-md p-2  "
            >
              <p>
                <Skeleton
                  sx={{ margin: "15px auto" }}
                  animation="wave"
                  variant="rectangular"
                  width={100}
                  height={20}
                />
              </p>
              <p>
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
              </p>
              <div className="flex items-center gap-4 p-2 pb-0">
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton
                  sx={{ margin: "3px 0px" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                  width={150}
                />
              </div>
              <div className="flex items-center gap-4 p-2">
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton
                  sx={{ margin: "3px 0px" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                  width={150}
                />
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {linkList.map((link, index) => (
            <div
              key={index}
              className=" border border-gray-300 py-3 mx-auto mt-0 m-5 rounded-md px-3  "
            >
              <p className="text-center text-secondary font-normal md:font-semibold text-lg capitalize pb-3 p-2 text-ellipsis">
                {link.Name}
              </p>
              <p className=" text-sm text-left font-light md:font-normal">{link.About}</p>
              <div className="flex items-center gap-4 p-2 pb-2 text-primary font-normal">
                <FaGlobe className="text-xl" />{" "}
                <div className="text-sm text-primary"
                 onClick={() =>
                  navigate("/web_links", {
                    state: {
                      title: link.Name ,
                      link: link.Website,
                      type:"website"
                    },
                  })}

                >
                  Helpful Link
                </div>
              </div>
              {link.Phone ? (
                <a  className="flex items-center gap-4 p-2 mb-3 text-[#4cadc9]">
                  <FaPhoneAlt /> <p className="text-sm">{link.Phone}</p>
                </a>
              ) : null}
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default LinkList;
